//import {authRoles} from 'auth/auth';

export const fuseNavigationConfig = [
  {
    'id': 'dashboard-component',
    'title': 'Dashboard',
    'type': 'item',
    'icon': 'dashboard',
    'auth' : ["admin","super"],
    'url': '/dashboard',
  },
  {
    'id': 'investors-component',
    'title': 'Investors',
    'type': 'item',
    'icon': 'account_box',
    'auth' : ["super","investors"],
    'url': '/investors'
  },
  {
    'id': 'kyc-component',
    'title': 'KYC',
    'type': 'item',
    'icon': 'account_box',
    'auth' : ["super","kyc"],
    'url': '/kyc'
  },
  {
    'id': 'OO-component',
    'title': 'Open Orders',
    'type': 'item',
    'icon': 'assignment_turned_in',
    'auth' : ["super","investors"],
    'url': '/openorders'
  },
  {
    'id': 'inbound-component',
    'title': 'Inbound',
    'type': 'item',
    'icon': 'assignment_turned_in',
    'auth' : ["super","inbound"],
    'url': '/inbound'
  },
  {
    'id': 'outbound-component',
    'title': 'Outbound',
    'type': 'item',
    'icon': 'assignment_return',
    'auth' : ["super","outbound"],
    'url': '/outbound'
  },
  {
    'id': 'reporting-component',
    'title': 'Reporting',
    'type': 'item',
    'icon': 'insert_drive_file',
    'auth' : ["super","reporting"],
    'url': '/reporting'
  },
  {
    'id': 'rec-component',
    'title': 'Reconciliation',
    'type': 'item',
    'icon': 'assignment_turned_in',
    'auth' : ["super"],
    'url': '/reconciliation'
  },
  {
    'id': 'MO-component',
    'title': 'Mail Out',
    'type': 'item',
    'icon': 'assignment_turned_in',
    'auth' : ["super"],
    'url': '/mailout'
  },
];
